import React from 'react';
import { Box } from '@mui/material';
import '../../styles/fonts/fonts.css';
import "./StyledButton.css"

interface StyledButtonProps {
    label: string;
    type: string;
    onClick?: VoidFunction;
    form?: string;
    disabled?: boolean;
    endAdornment?: React.ReactNode;
}

const StyledButton = ({
    label,
    type,
    onClick,
    form,
    disabled,
    endAdornment,
    ...props
}: StyledButtonProps) => {
    const content = (
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
            <span>{label}</span>
            {endAdornment}
        </Box>
    );

    if (form) {
        return (
            <button
                className={`btn-ctr${type === "filled" ? ' filled-outer' : ' outlined-outer'}`}
                style={{ border: 'none' }}
                onClick={onClick}
                form={form}
                disabled={disabled}
                {...props}
            >
                <span className={`btn-spn${type === "filled" ? ' filled-span' : ' outlined-span'}`}>
                    {content}
                </span>
            </button>
        );
    }

    return (
        <div
            className={`btn-ctr${type === "filled" ? ' filled-outer' : ' outlined-outer'}`}
            onClick={disabled ? undefined : onClick}
            style={{
                opacity: disabled ? 0.7 : 1,
                cursor: disabled ? 'not-allowed' : 'pointer',
            }}
            {...props}
        >
            <span className={`btn-spn${type === "filled" ? ' filled-span' : ' outlined-span'}`}>
                {content}
            </span>
        </div>
    );
};

export default StyledButton;